import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { linksList } from "./linksList";
import { HeaderLink, HeaderLinkMobile } from "../../atoms";
import "./styles.css";
import { Drawer } from "antd";

function HeaderMenu() {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  return (
    <div className="header_menu">
      {open && (
        <Drawer
          placement={"left"}
          closable={false}
          onClose={onClose}
          open={open}
          key={"left"}
        >
          <div style={{ backgroundColor: "gray", height: "100%", padding: 20 }}>
            {linksList.map((link) => (
              <HeaderLinkMobile link={link} key={link.id} setOpen={setOpen} />
            ))}
          </div>
        </Drawer>
      )}
      <div className="header_menu_desktop">
        {linksList.map((link) => (
          <HeaderLink link={link} key={link.id} />
        ))}
      </div>
      <div className="header_menu_mobile" onClick={showDrawer}>
        <svg width="1em" height="1em">
          <linearGradient
            id="blue-gradient"
            x1="100%"
            y1="100%"
            x2="0%"
            y2="0%"
          >
            <stop stopColor="#B07E33" offset="0%" />
            <stop stopColor="#C7A570" offset="25%" />
            <stop stopColor="#D7B357" offset="50%" />
            <stop stopColor="#AA8854" offset="75%" />
            <stop stopColor="#6F5124" offset="100%" />
          </linearGradient>
        </svg>
        <GiHamburgerMenu
          className="menu_mobile"
          style={{ fill: "url(#blue-gradient)" }}
        />
      </div>
    </div>
  );
}

export default HeaderMenu;
